import { FC } from 'react';
import { camelToNormalize } from '@repo-level/core-front';

import { ScErrorGroup } from './styled';

import error from 'theme/images/errorIcon.svg';
import { ImageComponent } from 'components/Image';

export const ErrorGroup: FC = ({ children }) => {
  return (
    <ScErrorGroup>
      <ImageComponent width={24} height={24} src={error} alt="error" />
      {children}
    </ScErrorGroup>
  );
};

export type ErrorServe = {
  field: string;
  message: string | string[];
};

export const ErrorGroupList: FC<{ errors: ErrorServe[] }> = ({ errors }) => {
  return errors.length ? (
    <ErrorGroup>
      <ul>
        {errors.map(({ field, message }, index) => (
          <li key={index}>
            <span>{camelToNormalize(field)}</span>:{' '}
            {typeof message === 'string' ? message : message.join(', ')}
          </li>
        ))}
      </ul>
    </ErrorGroup>
  ) : null;
};
